<template>
  <div class="list-filter">
    <button type="button" class="filter-btn" @click="openDetail">
      <span class="lbl">{{ label || field }}</span>
      <span class="arrow">▾</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ListFilter',
  props: {
    field: { type: String, required: true },
    options: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    initialSelected: { type: Array, default: () => [] }
  },

  data() {
    return { selectedOptions: Array.isArray(this.initialSelected) ? [...this.initialSelected] : [] }
  },

  watch: {
    initialSelected(newV) { this.selectedOptions = Array.isArray(newV) ? [...newV] : [] }
  },

  methods: {
    applyFilter() { this.$emit('filter', { key: this.field, value: this.selectedOptions }) },
    openDetail() {
      this.$emit('openDetail', { key: this.field, options: this.options || [], label: this.label || this.field })
    }
  }
}
</script>

<style scoped>
.filter-btn{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:10px 12px;
  border-radius:10px;
  background:transparent;
  border:1px solid rgba(0,0,0,0.04);
  cursor:pointer;
  font-weight:700;
  color:#222;
  transition: transform .12s ease, box-shadow .12s ease;
}
.filter-btn .lbl{ text-align:left; font-weight:700; color:#222; }
.filter-btn .arrow{ margin-left:8px; color:#666; font-weight:700; transition: transform .18s ease; transform-origin:center; }
</style>
